import Tools from '../../tools/Tools';
import EventDispatcher from '../../events/EventDispatcher';
import Events from '../../events/Events';
import ValidateCheckout from './step5/ValidateCheckout';

export default class Step5{
	constructor(view,lang){
		console.log('Step5 :: init',view);

		this.view 		= view;
		this.newsletter = this.view.querySelector('#newsletter');
		this.terms 		= this.view.querySelector('#terms');
        this.note      = this.view.querySelector('#note');
		this.totalLeft	= this.view.querySelector('.block_total .left');
		this.totalRight	= this.view.querySelector('.block_total .right .total');
		this.st			= this.totalLeft.querySelector('.st span:last-child');

		this.validateCheckout = new ValidateCheckout(this.view);

		this.submitForm = this.submitForm.bind(this);

		if (this.newsletter)
		    this.newsletter.addEventListener('change', this.onCheckNewsletter.bind(this));

		if (this.terms)
		    this.terms.addEventListener('change', this.onCheckTerms.bind(this));

        if (this.note)
            this.note.addEventListener('change', this.onCheckNote.bind(this));
	}

	load(response,currency){
		console.log('Step 5 :: Load :: ', response);

		//block totals
		let st 		= response.totals.subtotal;
		let taxes 	= response.totals.taxes;
		let total 	= response.totals.total;
        let key     = response.key;

        EventDispatcher.trigger(window, Events.Checkout.RETRIEVED_KEY, true, true, atob(key));

		this.totalLeft.querySelectorAll('div:not(.st)').forEach(div =>{
			div.remove();
		});

		document.querySelector('.inputs_invalid').classList.add('hidden');

		for(let key in taxes){
			let div = document.createElement('div');
			div.classList.add('row');
			let span1 = document.createElement('span');
			let span2 = document.createElement('span');

	        span1.innerHTML = taxes[key].name;
	        span2.innerHTML = taxes[key].amount;

			div.appendChild(span1);
			div.appendChild(span2);
			this.totalLeft.appendChild(div);
		}

		this.st.innerHTML = st;
		this.totalRight.innerHTML = total;

		let sup = document.createElement('sup');
		sup.innerHTML = currency;
		this.totalRight.appendChild(sup);

		//block receipt
		let formData = response.confirmation,
			event_date 	= this.view.querySelector('.event_date'),
			event_time 	= this.view.querySelector('.event_time'),
			location 	= this.view.querySelector('.location'),
			duration 	= this.view.querySelector('.duration'),
			packages 	= this.view.querySelector('.package'),
			people 		= this.view.querySelector('.people'),
			option 		= this.view.querySelector('.option');

		event_date.innerHTML 	= formData.date.formatted;
		event_time.innerHTML 	= formData.time;
		location.innerHTML 		= formData.location;
		duration.innerHTML 		= formData.duration;
		packages.innerHTML 		= formData.package;
		people.innerHTML 		= formData.passengers;
		option.innerHTML 		= formData.option;

		Tools.scrollTo(0,$(document.querySelector('section.reservation .container')).offset().top - 40);

	}

	onCheckNewsletter(e){
		e.preventDefault();

		if(e.target.checked) this.validateCheckout.formValidate.newsletter = true;
		else this.validateCheckout.formValidate.newsletter = false;

	}

	onCheckTerms(e){
		e.preventDefault();

		if(e.target.checked) this.validateCheckout.formValidate.terms = true;
		else this.validateCheckout.formValidate.terms = false;

	}

    onCheckNote(e){
        e.preventDefault();

        if(e.target.checked) this.validateCheckout.formValidate.note = true;
        else this.validateCheckout.formValidate.note = false;

    }

	submitForm(e){
		e.preventDefault();

		if(window.innerWidth <= 640)
			Tools.scrollTo(0,$(document.querySelector('.container')).offset().top - 40);

		this.validateCheckout.validate();
	}


}